import React

from "react";

import {

    OMNISCAN_BLUE

}

from "../../../constants/colors";

import DocumentPage

from "./DocumentPage";



//========================================================
// Document Canvas
//
// Displays the working document layout.
//
// Document creation itself is owned by the parent
// SnippetDocumentBuilder component because the parent has
// access to both:
//
//     - documentLayout
//     - documentBasket
//
// This component simply raises onCreateDocument when the
// user has finished composing the document.
//========================================================

export default function DocumentCanvas({

    documentLayout,

    basketItems = [],

    onAddPage,

    onDeletePage,

    onAddRow,

    onDeleteRow,

    onMoveRow,

    onChangeRowLayout,

    onSetCellContent,

    onClearCellContent,

    onUpdateCellContent,

    onSetPageOrientation,

    onCreateDocument

})

{

    //========================================================
    // Pages
    //========================================================

    const pages =

        Array.isArray(

            documentLayout?.pages

        )

            ?

            documentLayout.pages

            :

            [];



    //========================================================
    // Has Document Content
    //
    // Allow document creation when at least one cell
    // contains:
    //
    // - A basket item
    // - Authored text
    // - An uploaded image
    //
    // This is a UI check only. The parent and backend
    // must still validate the actual document request.
    //========================================================

    const hasDocumentContent =

        pages.some(

            page =>

                Array.isArray(

                    page?.rows

                )

                &&

                page.rows.some(

                    row =>

                        Array.isArray(

                            row?.cells

                        )

                        &&

                        row.cells.some(

                            cell =>

                            {

                                const content =
                                    cell?.content;

                                if (
                                    !content
                                )
                                {
                                    return false;
                                }

                                // Source or derived basket content.

                                if (
                                    content.basketId != null
                                )
                                {
                                    return true;
                                }

                                // Authored text, including a title.

                                if (
                                    content.contentType === "TEXT"
                                )
                                {

                                    return Boolean(

                                        content.title?.trim() ||

                                        content.text?.trim() ||

                                        content.html?.trim()

                                    );

                                }

                                // Locally uploaded image.

                                if (
                                    content.contentType ===
                                    "UPLOADED_IMAGE"
                                )
                                {

                                    return Boolean(
                                        content.imageFile
                                    );

                                }

                                return false;

                            }

                        )

                )

        );



    //========================================================
    // Create Document
    //========================================================

    const createDocument = () =>

    {

        if (

            !hasDocumentContent

        )

        {

            return;

        }



        if (

            !onCreateDocument

        )

        {

            return;

        }



        onCreateDocument();

    };



    //========================================================
    // Render
    //========================================================

    return (

        <div style={styles.canvas}>

            <div style={styles.pages}>

                {

                    pages.map(

                        (page, index) =>

                            <React.Fragment

                                key={

                                    page.id

                                }

                            >

                                <DocumentPage

                                    page={

                                        page

                                    }

                                    pageNumber={

                                        index + 1

                                    }

                                    canDelete={

                                        pages.length > 1

                                    }

                                    basketItems={

                                        basketItems

                                    }

                                    onDeletePage={

                                        onDeletePage

                                    }

                                    onAddRow={

                                        onAddRow

                                    }

                                    onDeleteRow={

                                        onDeleteRow

                                    }

                                    onMoveRow={

                                        onMoveRow

                                    }

                                    onChangeRowLayout={

                                        onChangeRowLayout

                                    }

                                    onSetCellContent={

                                        onSetCellContent

                                    }

                                    onClearCellContent={

                                        onClearCellContent

                                    }

                                    onUpdateCellContent={

                                        onUpdateCellContent

                                    }

                                    onSetPageOrientation={

                                        onSetPageOrientation

                                    }

                                />



                                {/*================================
                                    Page Break
                                =================================*/}

                                {

                                    index < pages.length - 1 &&

                                    (

                                        <div style={styles.pageBreak}>

                                            <div

                                                style={

                                                    styles.pageBreakLine

                                                }

                                            />

                                            <span>

                                                PAGE BREAK

                                            </span>

                                            <div

                                                style={

                                                    styles.pageBreakLine

                                                }

                                            />

                                        </div>

                                    )

                                }

                            </React.Fragment>

                    )

                }



                {/*============================================
                    Document Actions
                ============================================*/}

                <div style={styles.documentActions}>

                    {/*========================================
                        Add Page
                    ========================================*/}

                    <button

                        type="button"

                        style={

                            styles.addPageButton

                        }

                        onClick={

                            onAddPage

                        }

                    >

                        <span style={styles.addIcon}>

                            +

                        </span>

                        <span>

                            Add Page

                        </span>

                    </button>



                    {/*========================================
                        Create Document
                    ========================================*/}

                    <button

                        type="button"

                        style={

                            {

                                ...styles.createDocumentButton,

                                ...(

                                    !hasDocumentContent

                                        ?

                                        styles.createDocumentButtonDisabled

                                        :

                                        {}

                                )

                            }

                        }

                        onClick={

                            createDocument

                        }

                        disabled={

                            !hasDocumentContent

                        }

                    >

                        <span>

                            Create Document

                        </span>

                        <span style={styles.createArrow}>

                            →

                        </span>

                    </button>

                </div>

            </div>

        </div>

    );

}



//========================================================
// Styles
//========================================================

const styles =

{

    canvas:

    {

        width:

            "100%",

        height:

            "100%",

        overflowY:

            "auto",

        overflowX:

            "auto",

        padding:

            "42px 60px 80px 60px",

        boxSizing:

            "border-box",

        background:

            "#e9eef2"

    },

    pages:

    {

        width:

            "fit-content",

        minWidth:

            "100%",

        display:

            "flex",

        flexDirection:

            "column",

        alignItems:

            "center"

    },



    //========================================================
    // Page Break
    //========================================================

    pageBreak:

    {

        width:

            794,

        maxWidth:

            "calc(100vw - 180px)",

        height:

            54,

        display:

            "flex",

        alignItems:

            "center",

        gap:

            12,

        color:

            "rgba(38,55,70,0.30)",

        fontSize:

            8,

        fontWeight:

            700,

        letterSpacing:

            1.2

    },

    pageBreakLine:

    {

        flex:

            1,

        height:

            1,

        background:

            "rgba(38,55,70,0.12)"

    },



    //========================================================
    // Document Actions
    //========================================================

    documentActions:

    {

        width:

            794,

        maxWidth:

            "calc(100vw - 180px)",

        marginTop:

            20,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        gap:

            12

    },



    //========================================================
    // Add Page
    //========================================================

    addPageButton:

    {

        height:

            42,

        padding:

            "0 18px",

        display:

            "flex",

        alignItems:

            "center",

        gap:

            8,

        border:

            "1px solid rgba(32,175,232,0.34)",

        borderRadius:

            6,

        background:

            "#ffffff",

        color:

            OMNISCAN_BLUE,

        fontSize:

            11,

        fontWeight:

            600,

        cursor:

            "pointer",

        boxShadow:

            "0 4px 12px rgba(20,35,50,0.05)"

    },

    addIcon:

    {

        fontSize:

            18,

        fontWeight:

            400,

        lineHeight:

            1

    },



    //========================================================
    // Create Document
    //========================================================

    createDocumentButton:

    {

        height:

            42,

        minWidth:

            158,

        padding:

            "0 18px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        gap:

            12,

        border:

            "1px solid " + OMNISCAN_BLUE,

        borderRadius:

            6,

        background:

            OMNISCAN_BLUE,

        color:

            "#ffffff",

        fontSize:

            11,

        fontWeight:

            600,

        cursor:

            "pointer",

        boxShadow:

            "0 5px 14px rgba(32,175,232,0.20)",

        transition:

            "opacity 160ms ease, box-shadow 160ms ease"

    },

    createDocumentButtonDisabled:

    {

        opacity:

            0.38,

        cursor:

            "default",

        boxShadow:

            "none"

    },

    createArrow:

    {

        position:

            "relative",

        top:

            -1,

        fontSize:

            17,

        fontWeight:

            300,

        lineHeight:

            1

    }

};